/* eslint-disabled */
import Property from "./Property";
import Avenant from "./Avenant";
import PropertyValueExtend from "@/entity/extends/PropertyValueExtend";

export default class PropertyValue extends PropertyValueExtend {

public id!: number;
public value? = '';
public createdAt?: Date;
public removedAt?: Date;
public property!: Property;
public avenant!: Avenant;

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.value= object.value;
       if(object.createdAt){
           this.createdAt= new Date(object.createdAt);
       }
       if(object.removedAt){
           this.removedAt= new Date(object.removedAt);
       }
this.property = (object.property instanceof Property) ? object.property : object.property ? new Property(object.property) : object.property;
this.avenant = (object.avenant instanceof Avenant) ? object.avenant : object.avenant ? new Avenant(object.avenant) : object.avenant;
      }
      this.postConstruct()
  }

}
